import { GatsbyImage, StaticImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';
import React from 'react';

import useArticle from '../../hooks/use_article';
import useTranslation from '../../hooks/use_translation';
import BadgeContainer from '../framework/badges/badge_container';
import BadgeDiscount from '../framework/badges/badge-discount';
import Carousel from '../framework/carousel/carousel';
import ProductGroupIcon from './product-group-icon';

const ProductImages = ({
	group,
	group_id,
	onlyFirstImage,
	product,
	size = 'default',
	variant,
}) => {
	const image_header = product?.fields?.files_header_url_src;
	const { items: sampling_articles } = useArticle({
		include_products: [product?.product_id],
		include_types: ['sampling'],
	});
	const { language, t } = useTranslation('component_product_images');

	const sizes = { default: '', sm: '-sm' };

	return (
		<div
			className={`grid-product-item-image product-carousel${sizes[size]} bg-gray-100 position-relative`}
		>
			<Carousel hideButtons={onlyFirstImage} hideIndicators={onlyFirstImage}>
				{image_header && (
					<Carousel.Item key="image_header">
						<GatsbyImage
							alt={variant.title}
							className={`product-carousel-image${sizes[size]}`}
							draggable="false"
							image={getImage(image_header)}
						/>
					</Carousel.Item>
				)}
				{!image_header && (
					<Carousel.Item key="image_header_icon">
						<div className="p-5">
							<ProductGroupIcon
								alt={group.title}
								groups={[group_id]}
								type="product_img"
							/>
						</div>
					</Carousel.Item>
				)}
				{!onlyFirstImage &&
					product.product_settings?.include_biological_age && (
						<Carousel.Item>
							<StaticImage
								alt={t('t6')}
								className="product-carousel-image"
								draggable="false"
								key="static_image_3_sv"
								src={`../../images/product/zample-bioage.jpg`}
							/>
						</Carousel.Item>
					)}
				{!onlyFirstImage && (
					<Carousel.Item caption={t('t1')} key="static_image_1">
						<StaticImage
							alt={t('t2')}
							className="product-carousel-image"
							draggable="false"
							src={`../../images/product/zample-health-analytics.jpg`}
						/>
					</Carousel.Item>
				)}
				{!onlyFirstImage && sampling_articles?.length && (
					<Carousel.Item caption={t('t3')} key="static_image_2">
						<StaticImage
							alt={t('t4')}
							className="product-carousel-image"
							draggable="false"
							src={`../../images/product/blood-sample.jpg`}
						/>
					</Carousel.Item>
				)}

				{!onlyFirstImage &&
					product.product_settings?.include_statement &&
					product.type != ('addon' || 'specialist') && (
						<Carousel.Item caption={t('t5')}>
							{language === 'sv' ? (
								<StaticImage
									alt={t('t6')}
									className="product-carousel-image"
									draggable="false"
									key="static_image_3_sv"
									src={`../../images/product/doctor-se.jpg`}
								/>
							) : (
								<StaticImage
									alt=""
									className="product-carousel-image"
									draggable="false"
									key="static_image_3_en"
									src={`../../images/product/doctor-en.jpg`}
								/>
							)}
						</Carousel.Item>
					)}
			</Carousel>
			{!onlyFirstImage && variant.price_discount && (
				<BadgeContainer position="top_right">
					<BadgeDiscount
						className="mb-3"
						price={variant.price}
						price_discount={variant.price_discount}
					/>
				</BadgeContainer>
			)}
		</div>
	);
};

ProductImages.propTypes = {
	group: PropTypes.object,
	group_id: PropTypes.object,
	onlyFirstImage: PropTypes.bool,
	product: PropTypes.object,
	size: PropTypes.string,
	variant: PropTypes.object,
};

export default ProductImages;
